import type { FC } from "react";

import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Typography } from "~/shared/ui-kit/typography/Typography";

type ModalHandlerProps = {
  descriptionText: string;
  descriptionLinkText: string;
  handleClick: () => void;
};
export const ModalHandlerBlock: FC<ModalHandlerProps> = ({
  descriptionText,
  descriptionLinkText,
  handleClick,
}) => {
  return (
    <Flex className="mt-4" gap={8}>
      <Typography size="large">{descriptionText}</Typography>

      <Typography
        onClick={handleClick}
        size="large"
        className="text-[#D24128] cursor-pointer"
      >
        {descriptionLinkText}
      </Typography>
    </Flex>
  );
};
